import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded"

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 400,
    bgcolor: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.14)",
    p: "32px",
    outline: "none",
    textAlign: "center",
};

export function GlobalSuccessModal({ open, handleClose, title, subtitle, show, onClose }) {
    const isVisible = open ?? show ?? false;
    const handleDismiss = handleClose ?? onClose;

    return (
        <Modal keepMounted open={isVisible} onClose={handleDismiss}>
            <Box sx={style}>
                <Box
                    sx={{
                        width: 56,
                        height: 56,
                        borderRadius: "50%",
                        backgroundColor: "#e8f5e9",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto",
                        mb: 2,
                    }}
                >
                    <CheckCircleOutlineIcon sx={{ color: "#4caf50", fontSize: 32 }} />
                </Box>

                <Typography variant="h6" sx={{ fontWeight: 700, color: "#012442", mb: subtitle ? 1 : 3 }}>
                    {title}
                </Typography>

                {subtitle && (
                    <Typography sx={{ color: "#666666", fontSize: 14, mb: 3, px: 2 }}>
                        {subtitle}
                    </Typography>
                )}

                <Button
                    variant="contained"
                    onClick={(e) => {
                        if (e) {
                            e.stopPropagation();
                            e.preventDefault();
                        }
                        if (handleDismiss) handleDismiss();
                    }}
                    sx={{
                        backgroundColor: "#ff3b1d",
                        borderRadius: "999px",
                        px: 5,
                        py: 1,
                        fontWeight: 700,
                        textTransform: "none",
                        fontSize: "15px",
                        boxShadow: "none",
                        "&:hover": { backgroundColor: "#e63519", boxShadow: "none" },
                    }}
                >
                    Ok
                </Button>
            </Box>
        </Modal>
    );
}

export default GlobalSuccessModal;

export function GlobalErrorModal({ open, handleClose, title, subtitle, show, onClose }) {
    const isVisible = open ?? show ?? false;
    const handleDismiss = handleClose ?? onClose;

    return (
        <Modal keepMounted open={isVisible} onClose={handleDismiss}>
            <Box sx={style}>
                <Box
                    sx={{
                        width: 56,
                        height: 56,
                        borderRadius: "50%",
                        backgroundColor: "#ffebee",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto",
                        mb: 2,
                    }}
                >
                    <HighlightOffIcon sx={{ color: "#f44336", fontSize: 36 }} />
                </Box>

                <Typography variant="h6" sx={{ fontWeight: 700, color: "#012442", mb: subtitle ? 1 : 3 }}>
                    {title}
                </Typography>

                {subtitle && (
                    <Typography sx={{ color: "#666666", fontSize: 14, mb: 3, px: 2 }}>
                        {subtitle}
                    </Typography>
                )}

                <Button
                    variant="contained"
                    onClick={(e) => {
                        if (e) {
                            e.stopPropagation();
                            e.preventDefault();
                        }
                        if (handleDismiss) handleDismiss();
                    }}
                    sx={{
                        backgroundColor: "#ff3b1d",
                        borderRadius: "999px",
                        px: 5,
                        py: 1,
                        fontWeight: 700,
                        textTransform: "none",
                        fontSize: "15px",
                        boxShadow: "none",
                        "&:hover": { backgroundColor: "#e63519", boxShadow: "none" },
                    }}
                >
                    Ok
                </Button>
            </Box>
        </Modal>
    );
}

export function GlobalWarningGlobal({ open, handleClose, title, subtitle, show, onClose }) {
    const isVisible = open ?? show ?? false;
    const handleDismiss = handleClose ?? onClose;

    return (
        <Modal keepMounted open={isVisible} onClose={handleDismiss}>
            <Box sx={style}>
                <Box
                    sx={{
                        width: 56,
                        height: 56,
                        borderRadius: "50%",
                        backgroundColor: "#fff8e1",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto",
                        mb: 2,
                    }}
                >
                    <WarningAmberRoundedIcon sx={{ color: "#ff9800", fontSize: 36 }} />
                </Box>

                <Typography variant="h6" sx={{ fontWeight: 700, color: "#012442", mb: subtitle ? 1 : 3 }}>
                    {title}
                </Typography>

                {subtitle && (
                    <Typography sx={{ color: "#666666", fontSize: 14, mb: 3, px: 2 }}>
                        {subtitle}
                    </Typography>
                )}

                <Button
                    variant="contained"
                    onClick={(e) => {
                        if (e) {
                            e.stopPropagation();
                            e.preventDefault();
                        }
                        if (handleDismiss) handleDismiss();
                    }}
                    sx={{
                        backgroundColor: "#ff3b1d",
                        borderRadius: "999px",
                        px: 5,
                        py: 1,
                        fontWeight: 700,
                        textTransform: "none",
                        fontSize: "15px",
                        boxShadow: "none",
                        "&:hover": { backgroundColor: "#e63519", boxShadow: "none" },
                    }}
                >
                    Ok
                </Button>
            </Box>
        </Modal>
    )
}

export function GlobalConfirmModal({ open, handleClose, handleConfirm, title, subtitle, show, onClose }) {
    const isVisible = open ?? show ?? false;
    const handleDismiss = handleClose ?? onClose;

    return (
        <Modal keepMounted open={isVisible} onClose={handleDismiss}>
            <Box sx={style}>
                <Box
                    sx={{
                        width: 56,
                        height: 56,
                        borderRadius: "50%",
                        backgroundColor: "#fff8e1",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto",
                        mb: 2,
                    }}
                >
                    <WarningAmberRoundedIcon sx={{ color: "#ff9800", fontSize: 36 }} />
                </Box>

                <Typography variant="h6" sx={{ fontWeight: 700, color: "#012442", mb: subtitle ? 1 : 3 }}>
                    {title || "Deseja mesmo excluir?"}
                </Typography>

                {subtitle && (
                    <Typography sx={{ color: "#666666", fontSize: 14, mb: 3, px: 2 }}>
                        {subtitle}
                    </Typography>
                )}

                <Box sx={{ display: "flex", gap: 2, justifyContent: "center", mt: 2 }}>
                    <Button
                        variant="outlined"
                        onClick={(e) => {
                            if (e) {
                                e.stopPropagation();
                                e.preventDefault();
                            }
                            if (handleDismiss) handleDismiss();
                        }}
                        sx={{
                            borderColor: "#cccccc",
                            color: "#666666",
                            borderRadius: "999px",
                            px: 4,
                            py: 1,
                            fontWeight: 700,
                            textTransform: "none",
                            fontSize: "15px",
                            "&:hover": { borderColor: "#999999", backgroundColor: "#f5f5f5" },
                        }}
                    >
                        Não
                    </Button>
                    <Button
                        variant="contained"
                        onClick={(e) => {
                            if (e) {
                                e.stopPropagation();
                                e.preventDefault();
                            }
                            if (handleConfirm) handleConfirm();
                        }}
                        sx={{
                            backgroundColor: "#ff3b1d",
                            borderRadius: "999px",
                            px: 4,
                            py: 1,
                            fontWeight: 700,
                            textTransform: "none",
                            fontSize: "15px",
                            boxShadow: "none",
                            "&:hover": { backgroundColor: "#e63519", boxShadow: "none" },
                        }}
                    >
                        Sim
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}


